"use client";

import React from "react";

const LoadingSpinner = ({ 
  size = "medium", 
  message = "", 
  showMessage = false,
  minimal = false,
  className = ""
}) => {
  // Size configurations
  const sizeClasses = {
    small: "w-6 h-6",
    medium: "w-8 h-8", 
    large: "w-12 h-12",
    xlarge: "w-16 h-16"
  };

  const textSizes = {
    small: "text-xs",
    medium: "text-sm",
    large: "text-base", 
    xlarge: "text-lg"
  };

  if (minimal) {
    return (
      <>
        <div className={`inline-flex items-center ${className}`}>
          <div className={`${sizeClasses[size]} rounded-lg overflow-hidden`}>
            <img 
              src="/app-logo-alka.png" 
              alt="" 
              className="w-full h-full object-cover animate-gentle-pulse"
            />
          </div>
        </div>

        <style jsx>{`
          @keyframes gentle-pulse {
            0%, 100% {
              opacity: 0.8;
              transform: scale(1);
            }
            50% {
              opacity: 0.4;
              transform: scale(0.95);
            }
          }
          
          .animate-gentle-pulse {
            animation: gentle-pulse 2s ease-in-out infinite;
          }
        `}</style>
      </>
    );
  }

  return (
    <>
      <div className={`flex items-center justify-center ${className}`}>
        <div className="flex flex-col items-center gap-3">
          {/* Modern Alka Logo with subtle animation */}
          <div className={`relative ${sizeClasses[size]} rounded-lg overflow-hidden`}>
            <img 
              src="/app-logo-alka.png" 
              alt="" 
              className="w-full h-full object-cover animate-modern-fade"
            />
            {/* Subtle glow effect */}
            <div className={`absolute inset-0 bg-gradient-to-r from-[#D4AF37]/20 to-transparent rounded-lg blur-sm animate-glow`}></div>
          </div>
          
          {/* Loading Message */}
          {showMessage && message && (
            <p className={`text-gray-500 font-light tracking-wide ${textSizes[size]} animate-fade-in`}>
              {message}
            </p>
          )}
        </div>
      </div>

      {/* Modern CSS Animations */}
      <style jsx>{`
        @keyframes modern-fade {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.6;
            transform: scale(0.98);
          }
        }
        
        @keyframes glow {
          0%, 100% {
            opacity: 0.3;
          }
          50% {
            opacity: 0.6;
          }
        }
        
        @keyframes fade-in {
          0% {
            opacity: 0;
            transform: translateY(4px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-modern-fade {
          animation: modern-fade 2.5s ease-in-out infinite;
        }
        
        .animate-glow {
          animation: glow 2.5s ease-in-out infinite 0.5s;
        }
        
        .animate-fade-in {
          animation: fade-in 0.6s ease-out;
        }
      `}</style>
    </>
  );
};

export default LoadingSpinner;